import { api } from './client';

/** Отчёты о падениях приложения (T23): `GET /admin/app-crashes` в users-service, admin и manager. */

export type AppCrashKind = 'js-error' | 'unhandled' | 'previous-launch-crash';

export type AppCrashGroup = {
  id: number;
  kind: AppCrashKind;
  message: string;
  stack: string;
  route: string;
  app_version: string;
  app_build: string;
  platform: string;
  os_version: string;
  count: number;
  day: string;
  first_seen: string;
  last_seen: string;
};

export type AppCrashSummaryRow = {
  app_version: string;
  platform: string;
  os_version: string;
  count: number;
  groups: number;
};

export type AppCrashOverview = { groups: AppCrashGroup[]; summary: AppCrashSummaryRow[] };

export const appCrashesApi = {
  overview: () =>
    api.get<AppCrashOverview>('/admin/app-crashes').then((r) => ({
      // Пустой срез Go может прийти null — экран на .map упал бы.
      groups: r.data?.groups ?? [],
      summary: r.data?.summary ?? [],
    })),
};
